// ---------------------------------------------------------------------------
//  Runtime mode helpers (capture/test mode, reduced motion, pixel ratio)
// ---------------------------------------------------------------------------
/** True when running under a test/headless-capture harness (deterministic output). */
export const isCaptureMode = () => {
  if (typeof window === 'undefined') return false;
  try {
    const q = new URLSearchParams(window.location.search).get('capture');
    if (q === '0') return false; // explicit player-mode override (QA of the retina/non-capture path)
    if (import.meta?.env?.DCW_TEST_MODE === '1' || globalThis.DCW_TEST_MODE) return true;
    if (import.meta?.env?.VITE_QA_E2E === 'true') return true;
    if (typeof navigator !== 'undefined' && navigator.webdriver) return true;
    if (q === '1') return true;
  } catch { /* ignore */ }
  return false;
};

/** Output pixel ratio: device ratio capped at 2 for players, exactly 1 in capture mode. */
export const resolvePixelRatio = (capture = isCaptureMode()) => {
  if (capture || typeof window === 'undefined') return 1;
  return Math.max(1, Math.min(window.devicePixelRatio || 1, 2));
};

export const prefersReducedMotion = () => {
  try {
    return typeof window !== 'undefined' && !!window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch { return false; }
};

/** Default phosphor persistence (ms to fade to ~10%). 0 disables. */
export const DEFAULT_PHOSPHOR_PERSISTENCE_MS = 100;

/** Per-frame retention factor for a given persistence time (ms) and frame dt (s). */
export const persistenceDecay = (persistenceMs, dtSeconds) => {
  if (!(persistenceMs > 0)) return 0;
  return Math.pow(0.1, Math.max(0, dtSeconds) / (persistenceMs / 1000));
};
